/**
 * GIA Certificate Modal Fast Open
 * Overrides the default modal opening behavior for faster GIA certificate modals
 */
if (!customElements.get('gia-certificate-modal')) {
  class GIACertificateModal extends HTMLElement {
    constructor() {
      super();
      this.modal = null;
    }

    connectedCallback() {
      // Find the associated modal
      this.modal = this.querySelector('basic-modal.gia-certificate-modal');
      if (this.modal) {
        // Override the handleShowTransition method for faster opening
        const originalHandleShowTransition = this.modal.handleShowTransition;
        this.modal.handleShowTransition = function(animate = true) {
          if (!animate) {
            this.setAttribute('active', '');
            return Promise.resolve();
          }

          // Faster timeout for GIA certificate modal (25ms instead of 75ms)
          setTimeout(() => {
            this.setAttribute('active', '');
          }, 25);

          // Return promise that resolves when transition ends
          return new Promise((resolve) => {
            this.overlay.addEventListener('transitionend', resolve, { once: true });
          });
        };
      }
    }
  }

  customElements.define('gia-certificate-modal', GIACertificateModal);
}

// Also add a faster click handler specifically for GIA certificate links
document.addEventListener('DOMContentLoaded', function() {
  const giaCertificateLinks = document.querySelectorAll('.gia-certificate-link');
  
  giaCertificateLinks.forEach(link => {
    // Remove any existing click listeners and add our optimized one
    const newLink = link.cloneNode(true);
    link.parentNode.replaceChild(newLink, link);
    
    newLink.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      
      const modalId = this.getAttribute('aria-controls');
      const modal = document.getElementById(modalId);
      
      if (modal && modal.show) {
        // Use immediate show for even faster opening
        modal.show(this, true);
      }
    });
  });
});